import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Send } from "lucide-react";

export function SendRosterButton({ driverCount }) {
  const [sentAt, setSentAt] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/onboarding/checklist").then(({ data }) => setSentAt(data.items?.find((i) => i.key === "roster")?.sent_at || null)).catch(() => {}); }, [driverCount]);
  const send = async () => {
    if (!window.confirm("Email Britt & Jenn your current driver list so the random pool can be updated?")) return;
    setBusy(true);
    try { const { data } = await api.post("/onboarding/send-roster"); setSentAt(new Date().toISOString()); toast.success(`Driver list sent — ${data.active} active of ${data.drivers} drivers`); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-2">
      {sentAt && <span className="text-xs text-slate-500 font-mono hidden md:inline" data-testid="roster-last-sent">Last sent {new Date(sentAt).toLocaleDateString()}</span>}
      <Button variant="outline" onClick={send} disabled={busy || !driverCount} className="border-fuchsia-300 text-fuchsia-800 hover:bg-fuchsia-50" data-testid="send-roster-button" title="Email your driver list to Safer Highways so your random pool stays current">
        <Send className="h-4 w-4 mr-1" />{busy ? "Sending…" : sentAt ? "Re-send driver list" : "Send driver list"}
      </Button>
    </div>
  );
}
